<template>
  <div class="flex flex-col h-full">
    <div v-if="category" class="content">
      <div class="category-header" :class="category.slug">
        <div class="col-1 ml-3"></div>
        <h2 class="uppercase">{{ category.name }}</h2>
        <div class="col-6 category-background" :class="category.slug"></div>
      </div>
      <div class="profiles flex flex-wrap">
        <div class="col-md-4 col-xl-3 my-3" v-for="article in articlesByCategory" v-bind:key="article.id">
          <player-profile-link :article="article" :show-article-category-icon="false"></player-profile-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import { CategoryArticlesLoaded } from '@/common/guards/categoryArticlesLoaded.guard';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';
  import PlayerProfileLink from '@/views/Student/PlayerProfileLink';

  export default {
    name: 'index',

    components: {
      PlayerProfileLink
    },

    computed: {
      ...mapGetters(['articles', 'categories', 'category']),
      articlesByCategory: function () {
        const articles = this.articles.filter(b => b.categories.find(x => x.id === this.category.id));

        return _.orderBy(articles, ['last_name', 'first_name'], ['asc', 'asc']);
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: this.category.name, useBaseTitle: true})
    },

    watch: {
      category: function (newValue) {
        this.$store.dispatch(CHANGE_DOC_TITLE, {title: newValue.name, useBaseTitle: true})
      }
    },

    beforeRouteUpdate (to, from, next) {
      return CategoryArticlesLoaded(to, from, next);
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding-top: 236px;

    @media (min-width: config('screens.lg')) {
      padding-top: calc(config('staticHeight.header') + config('staticHeight.categoryCarousel') + config('staticHeight.breadcrumbs'));
    }
  }

  .category-header {
    @apply flex text-white items-center relative mb-3 w-full;
    height: 240px;

    h2 {
      z-index: 10;
    }

    .category-background {
      height: 240px;
      position: absolute;
      right: 0;
      top: 0;

      @media (min-width: config('screens.lg')) {
        left: 395px;
        right: auto;
      }

      &.basketball {
        background: no-repeat url("../../../assets/images/40-lrn-spt-cat-head-cat-1-540.svg");
      }

      &.football {
        background: no-repeat url("../../../assets/images/41-lrn-spt-cat-head-cat-2-540.svg");
      }

      &.baseball {
        background: no-repeat url("../../../assets/images/42-lrn-spt-cat-head-cat-3-540.svg");
      }

      &.soccer {
        background: no-repeat url("../../../assets/images/43-lrn-spt-cat-head-cat-4-540.svg");
      }

      &.more-sports {
        background: no-repeat url("../../../assets/images/more-sports-category-header.svg");
      }

      &.olympics {
        background: no-repeat url("../../../assets/images/olympics-category-header.svg");
      }

      &.hockey {
        background: no-repeat url("../../../assets/images/hockey-category-header.svg");
      }

      &.tennis {
        background: no-repeat url("../../../assets/images/tennis-category-header.svg");
      }
    }

    &.basketball {
      @apply bg-c1-b;
    }

    &.football {
      @apply bg-c2-b;
    }

    &.baseball {
      @apply bg-c3-b;
    }

    &.soccer {
      @apply bg-c4-b;
    }

    &.more-sports {
      @apply bg-c5-b;
    }

    &.olympics {
      @apply bg-c6-b;
    }

    &.hockey {
      @apply bg-c7-b;
    }

    &.tennis {
      @apply bg-c8-b;
    }
  }
</style>
